
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cog-icon cog-i-error-outline",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","focusable":"false","class":"cog-icon cog-i-error-outline"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',[_c('path',{staticClass:"cog-i-error-outline__triangle",attrs:{"stroke-miterlimit":"10","d":"M2.86 14.62L9 4.13l6.14 10.49H2.86z"}}),_c('g',{staticClass:"cog-i-error-outline__exclamation"},[_c('circle',{attrs:{"cx":"9","cy":"12.2","r":".74"}}),_c('path',{attrs:{"d":"M8.3 8.47l.12 2.18a.2.2 0 00.19.19h.78a.2.2 0 00.19-.19l.12-2.18a.2.2 0 00-.18-.2h-1a.19.19 0 00-.19.19z"}})])])])
          )
        }
      }
    